module.exports = __webpack_public_path__ + "static/media/dashboard.9f88f423.png";